export default __webpack_public_path__ + "static/alkemi-brand-guidelines-1fb09383198b6c72316dc50ec3730296.pdf";